"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIME_VALUES = void 0;
exports.TIME_VALUES = {
    halfFromSecondToLess: 29,
    halfFromMinuteToLess: 29,
    halfFromHourToLess: 11,
};
//# sourceMappingURL=timeValues.js.map